var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import flatMap from 'lodash/flatMap';
import find from 'lodash/find';
import map from 'lodash/map';
import isNil from 'lodash/isNil';
import forEach from 'lodash/forEach';
import memoizeOne from 'memoize-one';
import countries from 'i18n-iso-countries';
import { getFulfillmentLocations } from './services/fulfillementLocations';
import { getDeliveryLocations } from './services/deliveryLocations';
import { getProductionTime } from './services/productionTime'; // eslint-disable-next-line @typescript-eslint/no-var-requires

countries.registerLocale(require('i18n-iso-countries/langs/en.json'));
export var getFulfillmentLocationsIfExists = function getFulfillmentLocationsIfExists(productDetails, externalFulfillerId) {
  return __awaiter(void 0, void 0, void 0, function () {
    var response, fulfillmentLocation;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , getFulfillmentLocations(externalFulfillerId)];

        case 1:
          response = _a.sent();
          fulfillmentLocation = [];
          forEach(productDetails.fulfillmentLocations, function (location) {
            var item = find(response, {
              fulfillmentLocationId: location.externalFulfillmentLocationId
            });

            if (item) {
              fulfillmentLocation.push(item);
            }
          });
          return [2
          /*return*/
          , fulfillmentLocation];
      }
    });
  });
};
export var flatMapCountry = function flatMapCountry(subRegion) {
  var regionCountries = flatMap(subRegion.countries, function (country) {
    return {
      value: country.countryCode,
      label: country.name + " (" + country.countryCode + ")"
    };
  });
  return regionCountries;
};

var convertDeliveryLocationToOptions = function convertDeliveryLocationToOptions(deliveryLocations) {
  var allCountries = flatMap(deliveryLocations, function (eachDeliveryLocation) {
    return flatMap(eachDeliveryLocation.subRegions, flatMapCountry);
  });

  if (allCountries) {
    var orderedCountries = allCountries.sort(function (a, b) {
      if (a.label < b.label) {
        return -1;
      }

      if (a.label > b.label) {
        return 1;
      }

      return 0;
    });
    return orderedCountries;
  }

  return countries;
};

export var getDeliveryLocationsIfExists = function getDeliveryLocationsIfExists(sku) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      if (!sku) {
        return [2
        /*return*/
        , null];
      }

      return [2
      /*return*/
      , getDeliveryLocations(sku).catch(function () {// Doing nothing
      })];
    });
  });
};
export var convertFulfillmentLocationsToOptions = function convertFulfillmentLocationsToOptions(fulfillmentLocation) {
  return {
    value: fulfillmentLocation.fulfillmentLocationId,
    label: fulfillmentLocation.dispatchAddressCountry + " - " + fulfillmentLocation.name
  };
};
export var calculateDays = function calculateDays(units, time) {
  switch (units) {
    case 'DD':
      return {
        actualProductionTimeString: time + " days",
        productionTime: time,
        actualproductionTimeUnits: 'HH',
        actualProductionTime: time
      };

    case 'HH':
      return {
        actualProductionTimeString: time + " hrs",
        productionTime: Math.ceil(time / 24),
        actualproductionTimeUnits: 'HH',
        actualProductionTime: time
      };

    default:
      return 0;
  }
};
export var getProductionTimeIfExists = function getProductionTimeIfExists(productionTime, mcpSku) {
  return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (productionTime && productionTime > 0) return [2
          /*return*/
          , {
            actualProductionTimeString: productionTime + " hrs",
            productionTime: Math.ceil(productionTime / 24),
            actualproductionTimeUnits: 'HH',
            actualProductionTime: productionTime
          }];
          return [4
          /*yield*/
          , getProductionTime(mcpSku).catch(function () {// Doing nothing
          })];

        case 1:
          response = _a.sent();

          if (response) {
            return [2
            /*return*/
            , calculateDays(response.Units, response.Time)];
          }

          return [2
          /*return*/
          , {
            actualProductionTimeString: 0 + " hrs",
            productionTime: 0,
            actualproductionTimeUnits: 'HH',
            actualProductionTime: 0
          }];
      }
    });
  });
};

var getDefaultCountryOptions = function getDefaultCountryOptions() {
  return map(countries.getNames('en'), function (countryName) {
    var countryCode = countries.getAlpha2Code(countryName, 'en');
    return {
      value: countryCode,
      label: countryName + " (" + countryCode + ")"
    };
  });
};

var hasLocations = function hasLocations(locations) {
  return !isNil(locations) && locations.length > 0;
};

export var getDeliveryLocationOptions = memoizeOne(function (deliveryLocations) {
  return hasLocations(deliveryLocations) ? convertDeliveryLocationToOptions(deliveryLocations) : getDefaultCountryOptions();
});
export var convertFulfillmentLocationToOptions = function convertFulfillmentLocationToOptions(fulfillmentLocations) {
  var options = [];
  if (!fulfillmentLocations || !Object.keys(fulfillmentLocations).length) return null;
  fulfillmentLocations.forEach(function (fulfillmentLocation) {
    options.push({
      value: fulfillmentLocation.fulfillmentLocationId,
      label: fulfillmentLocation.fulfillmentLocationName + " - " + fulfillmentLocation.fulfillmentLocationId
    });
  });
  return options;
};